import { create } from "zustand";

type Account = {
  email: "";
  name: "";
  phone: "";
  password: "";
};

interface SignUpState {
  account: Account;
  setAccount: (account: any) => void;
}

export const useSignUpStore = create<SignUpState>((set) => ({
  account: {
    email: "",
    name: "",
    phone: "",
    password: "",
  },
  setAccount: (account: Account) => set({ account }),
}));
